import { restClient } from '../client';
import { TimeRange, WeekDayKeys } from '@uplift/types';


export type AvailabilityTemplateOutput = {
  days: Record<WeekDayKeys, TimeRange[]>;
  timezone: string;
};


export type SetAvailabilityTemplateInput = {
  days: Partial<Record<WeekDayKeys, TimeRange[]>>;
  timezone?: string;
};


export type SetAvailabilityTemplateOutput = AvailabilityTemplateOutput;


export const setAvailabilityTemplate = (params: SetAvailabilityTemplateInput) => restClient.rawRequest<SetAvailabilityTemplateOutput>('/api/v1/availability_template', {
  method: 'POST',
  data: params,
});


export type GetAvailabilityTemplateOutput = AvailabilityTemplateOutput & {
  total_hours: number;
  configured: boolean;
  overrides: Record<string, TimeRange[]>;
};


export const getAvailabilityTemplate = (params?: { date_from: string; date_to: string }) => restClient.rawRequest<GetAvailabilityTemplateOutput>('/api/v1/availability_template', {
  method: 'GET',
  params: params
});


export const setAvailabilityOverride = (params: { date: string; ranges: TimeRange[] }) => restClient.rawRequest<{ ranges: TimeRange[] }>('/api/v1/availability_override', {
  method: 'POST',
  data: params,
});
